import React from 'react';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error, errorInfo });
        console.error('ErrorBoundary caught an error', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 20, color: 'red', wordWrap: 'break-word', fontFamily: 'sans-serif' }}>
                    <h2>Bir Hata Oluştu!</h2>
                    <p>Lütfen bu ekranın fotoğrafını çekip bana iletin:</p>
                    <p><strong>{this.state.error && this.state.error.toString()}</strong></p>
                    <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap', backgroundColor: '#f0f0f0', padding: '10px' }}>
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </pre>
                </div>
            );
        }

        return this.props.children;
    }
}
